export default "__VITE_ASSET__482ce6a5__"